var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      staticClass: "bet-triple-combo-btn",
      class: {
        "bet-triple-combo-btn--selected": _vm.selected,
        "bet-triple-combo-btn--mirrored": _vm.mirrored,
        "bet-triple-combo-btn--result-matched": _vm.resultMatched,
      },
      attrs: {
        type: "button",
        "aria-label": `Triple ${_vm.face}-${_vm.face}-${_vm.face}`,
      },
      on: {
        click: function ($event) {
          return _vm.$emit("click")
        },
      },
    },
    [
      _vm.mirrored
        ? _c("span", { staticClass: "bet-triple-combo-btn__odds" }, [
            _vm._v(_vm._s(_vm.odds)),
          ])
        : _vm._e(),
      _c(
        "span",
        { staticClass: "bet-triple-combo-btn__dice-group" },
        _vm._l(3, function (index) {
          return _c("img", {
            key: index,
            attrs: { src: _vm.diceImage(_vm.face), alt: "" },
          })
        }),
        0
      ),
      !_vm.mirrored
        ? _c("span", { staticClass: "bet-triple-combo-btn__odds" }, [
            _vm._v(_vm._s(_vm.odds)),
          ])
        : _vm._e(),
      _vm.amount
        ? _c("BetPlacedChip", {
            attrs: {
              amount: _vm.amount,
              chips: _vm.chips,
              placement: "top-right",
              overlap: "",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }